(function(window, mL, mL_errors, mL_events, mL_config) {
    "use strict";

    var key = 'zoom_info';

    function safe_start() {
        if (mL_config.do_not_track || !mL_config.tags || !mL_config.tags.zinfo) return;

        mL.zinfo = mL.zinfo || {};

        mL_events.subscribe('page', function(msg, data) {
            if (mL_config.AUDIT) console.log('pubsub ' + key + ' - ' + msg, data);
        });

        mL.zinfo.init = function() {
            if (mL.zinfo.is_init || !mL.add_tracker) return false;

            //mL.add_tracker('https://ws.zoominfo.com/pixel/61e053ffb9a6a900132785d4', 'zoom_info', false);

            var zi = document.createElement('script');
            zi.id = 'zoom_info';
            zi.type = 'text/javascript';
            zi.async = true;
            zi.referrerPolicy = 'unsafe-url';
            zi.src = 'https://ws.zoominfo.com/pixel/61e053ffb9a6a900132785d4';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(zi, s);

            mL.zinfo.is_init = true;

            if (mL_config.DEBUG) console.log(key + ' - plugin loaded');
        };

    }

    try {
        safe_start();
    } catch (err) {
        mL_errors(new Error('safe_start failed - ' + key.toUpperCase()));
        mL_errors(err);
    }


}(window, window.mL, window.mL_errors, window.mL_events, window.mL_config));